import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import {
  GetForm7501LinesBIZcoreTD
} from '../../../../../redux/actions/business/core/form7501LinesActions';

const Form7501LinesPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.tradeDefence"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [linesList, setLinesList] = useState([]);
  const [linesTotal, setLinesTotal] = useState(0);

  const [
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    { label: "Id", sort: "id" },
    { label: "Header id", sort: "ref_header_id" },
    { label: "Line number", sort: "line_number" },
    { label: "Raw TSUS HTS", sort: "raw_tsus_hts" },
    { label: "USITC HTS id", sort: "ref_usitc_hts_id" },
    { label: "SPI", sort: "spi" },
    { label: "Gross weight (kg)", sort: "gross_weight_kgs" },
    { label: "Manifest qty", sort: "manifest_quantity" },
    { label: "Manifest UOM", sort: "manifest_uom" },
    { label: "Entered value", sort: "entered_value_line_total" },
    { label: "Origin country", sort: "origin_country" },
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetLines();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      setLinesList(state.form7501LinesList.records || []);
      setLinesTotal(state.form7501LinesList.total || 0);
    } catch (err) {}
  }, [state]);

  async function handleGetLines(customLoading) {
    let query = "";
    if (search) query += `&search=${search}`;
    if (sort) query += `&ordering=${sortDirection === "asc" ? '' : '-'}${sort}`;
    dispatch(GetForm7501LinesBIZcoreTD(page + 1, rowsPerPage, query, true, customLoading ? customLoading : setLoading));
  };

  return (
    <Box>

      <TopBar
        title={"Form 7501 lines"}
        search={search}
        onSearchChange={(e) => setSearch(e.target.value)}
      />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          linesList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No Form 7501 line found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    <TableCell key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort}
                        direction={sortDirection}
                        onClick={() => handleSort(heading.sort)}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                linesList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.ref_header_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>{row.line_number ?? <NA />}</TableCell>
                    <TableCell>{row.raw_tsus_hts || <NA />}</TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.ref_usitc_hts_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>{row.spi || <NA />}</TableCell>
                    <TableCell>{row.gross_weight_kgs ?? <NA />}</TableCell>
                    <TableCell>{row.manifest_quantity ?? <NA />}</TableCell>
                    <TableCell>{row.manifest_uom || <NA />}</TableCell>
                    <TableCell>{row.entered_value_line_total ?? <NA />}</TableCell>
                    <TableCell>{row.origin_country || <NA />}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  colSpan={11}
                  count={linesTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
      }

    </Box>
  );
};

export default Form7501LinesPage;
